import React, { useEffect, useState } from "react";
import axios from "axios";

const MetaEmbeddedSignup = () => {
  // 🔹 Replace these with actual values from Meta Developer Dashboard
  const APP_ID = "874516431301713";
  const CONFIG_ID = "935380421944959";
  const API_VERSION = "v20.0";
  const solutionID = "3474617559499008"; // Optional
  const BACKEND_URL =
    "https://console.authkey.io/api/facebook_embeded_signup_karix.php";

  // 🔹 State to store signup details
  const [signupData, setSignupData] = useState({
    code: "",
    phone_number_id: "",
    waba_id: "",
  });

  const [isDataSent, setIsDataSent] = useState(false);

  // 🔹 Safely retrieve user details from localStorage
  const loginData = JSON.parse(localStorage.getItem("login") || "{}");
  const userId = loginData?.user?.userId || "";
  const userToken = loginData?.token || "";
  const username = loginData?.user?.username || "";

  // 🔹 Load Facebook SDK
  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: APP_ID,
        cookie: true,
        xfbml: true,
        version: API_VERSION,
      });
      console.log("✅ Facebook SDK Initialized");
    };

    const loadFacebookSDK = () => {
      if (document.getElementById("facebook-jssdk")) return;

      const js = document.createElement("script");
      js.id = "facebook-jssdk";
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      js.async = true;
      js.defer = true;
      js.crossOrigin = "anonymous";
      js.onload = () =>
        console.log("✅ Facebook SDK Script Loaded Successfully");

      document.body.appendChild(js);
    };

    loadFacebookSDK();

    // 🔹 Listen for WhatsApp Embedded Signup events
    const handleMessage = (event) => {
      const allowedOrigins = [
        "https://www.facebook.com",
        "https://web.facebook.com",
        "https://business.facebook.com",
      ];

      if (!allowedOrigins.includes(event.origin)) return;

      try {
        const data =
          typeof event.data === "string"
            ? JSON.parse(event.data)
            : event.data;

        if (data.type === "WA_EMBEDDED_SIGNUP") {
          if (data.event === "FINISH") {
            const { phone_number_id, waba_id } = data.data;

            setSignupData((prev) => ({
              ...prev,
              phone_number_id,
              waba_id,
            }));

            console.log("✅ Signup Finished:", data.data);
          }

          if (data.event === "CANCEL") {
            console.warn("⚠️ Signup Cancelled");
          }

          if (data.event === "ERROR") {
            console.error("❌ Signup Error:", data.data);
          }
        }
      } catch (error) {
        console.error("❌ Error parsing message:", error);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [APP_ID, API_VERSION]);

  // 🔹 Launch WhatsApp Embedded Signup
  const launchSignup = () => {
    console.log("🚀 Connect WhatsApp Business button clicked");

    if (!window.FB) {
      alert("Facebook SDK not loaded yet.");
      return;
    }

    window.FB.login(
      (response) => {
        console.log("📩 FB Login Response:", response);

        if (response.authResponse) {
          const code = response.authResponse.code;

          setSignupData((prev) => ({
            ...prev,
            code,
          }));
        } else {
          alert("User cancelled the login.");
        }
      },
      {
        config_id: CONFIG_ID,
        response_type: "code",
        override_default_response_type: true,
        extras: {
          setup: {},
          feature: "whatsapp_embedded_signup",
          sessionInfoVersion: 3,
          solutionID: solutionID,
        },
      }
    );
  };

  // 🔹 Send data to backend
  const sendDataToBackend = async () => {
    const { code, phone_number_id, waba_id } = signupData;

    if (!code || !phone_number_id || !waba_id || isDataSent) return;

    try {
      const payload = {
        accessToken: code,
        user_id: userId,
        user_name: username,
        method: "insert_token",
        pnid: phone_number_id,
        wabaid: waba_id,
        remark: "WhatsApp Embedded Signup",
      };

      const response = await axios.post(BACKEND_URL, payload, {
        headers: {
          "Content-Type": "application/json",
          ...(userToken && {
            Authorization: `Bearer ${userToken}`,
          }),
        },
      });

      console.log("✅ Backend Response:", response.data);
      alert("WhatsApp Business Account Connected Successfully!");
      setIsDataSent(true);
    } catch (error) {
      console.error("❌ Error sending data to backend:", error);
    }
  };

  // 🔹 Trigger backend call when all data is available
  useEffect(() => {
    if (
      signupData.code &&
      signupData.phone_number_id &&
      signupData.waba_id &&
      !isDataSent
    ) {
      sendDataToBackend();
    }
  }, [
    signupData.code,
    signupData.phone_number_id,
    signupData.waba_id,
    isDataSent,
  ]);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>WhatsApp Embedded Signup</h2>

      <button
        onClick={launchSignup}
        style={{
          backgroundColor: "#1877F2",
          color: "#fff",
          border: "none",
          padding: "12px 20px",
          fontSize: "16px",
          borderRadius: "6px",
          cursor: "pointer",
        }}
      >
        Connect WhatsApp Business
      </button>

      {(signupData.code ||
        signupData.phone_number_id ||
        signupData.waba_id) && (
        <div
          style={{
            marginTop: "30px",
            textAlign: "left",
            display: "inline-block",
          }}
        >
          <h3>Signup Details</h3>
          <p>
            <strong>Authorization Code:</strong> {signupData.code}
          </p>
          <p>
            <strong>Phone Number ID:</strong>{" "}
            {signupData.phone_number_id}
          </p>
          <p>
            <strong>WABA ID:</strong> {signupData.waba_id}
          </p>
        </div>
      )}
    </div>
  );
};

export default MetaEmbeddedSignup;